/**
 * 根据后端 recharge / buyVipPlanPay 返回的 payPayload，解析「可直接 window.open 的 http(s) 地址」。
 * - 微信 Native：返回二维码图床 URL（便于新窗口展示）
 * - 支付宝 PC 网页支付：SDK 常在 payUrl 字段返回「自动提交表单的 HTML」，不是链接；
 *   此时本函数对该字段返回空字符串，请改用 {@link openCashPayWindow}。
 * - 仅当 payPayload.provider === 'mock' 时才使用 mockPayUrl（联调）
 */

function isLikelyAlipayPagePayHtml(s) {
  const t = String(s || "").trim();
  if (t.length < 30 || t.charAt(0) !== "<") return false;
  const low = t.toLowerCase();
  return (
    low.includes("<form") &&
    (low.includes("alipaysubmit") || (low.includes("alipay") && low.includes("gateway")))
  );
}

export function resolveCashPayWindowUrl(payPayload, payType) {
  if (!payPayload || typeof payPayload !== "object") return "";
  const pt = String(payType || payPayload.payType || "").toLowerCase();
  const provider = String(payPayload.provider || "").toLowerCase();
  const payUrl = payPayload.payUrl != null ? String(payPayload.payUrl).trim() : "";
  const codeUrl = payPayload.codeUrl != null ? String(payPayload.codeUrl).trim() : "";
  const mockUrl = payPayload.mockPayUrl != null ? String(payPayload.mockPayUrl).trim() : "";

  if (pt === "alipay" && payUrl) {
    if (isLikelyAlipayPagePayHtml(payUrl)) return "";
    return payUrl;
  }
  if (pt === "wechat" && codeUrl) {
    const u = encodeURIComponent(codeUrl);
    return `https://api.qrserver.com/v1/create-qr-code/?size=280x280&data=${u}`;
  }
  if (payUrl) {
    if (isLikelyAlipayPagePayHtml(payUrl)) return "";
    return payUrl;
  }
  if (codeUrl) {
    const u = encodeURIComponent(codeUrl);
    return `https://api.qrserver.com/v1/create-qr-code/?size=280x280&data=${u}`;
  }
  if (provider === "mock" && mockUrl) return mockUrl;
  return "";
}

/**
 * 打开现金支付页：支付宝 HTML 表单写入新窗口；微信/其它走可打开的 URL。
 * @returns 是否已尝试打开（弹窗被拦截时可能为 false）
 */
export function openCashPayWindow(payPayload, payType) {
  if (!payPayload || typeof payPayload !== "object") return false;
  const pt = String(payType || payPayload.payType || "").toLowerCase();
  const raw = payPayload.payUrl != null ? String(payPayload.payUrl).trim() : "";

  if (raw && (pt === "alipay" || isLikelyAlipayPagePayHtml(raw)) && isLikelyAlipayPagePayHtml(raw)) {
    const w = window.open("", "_blank");
    if (!w) return false;
    try {
      w.document.open();
      w.document.write(raw);
      w.document.close();
    } catch (e) {
      try {
        w.close();
      } catch (e2) {
        /* ignore */
      }
      return false;
    }
    return true;
  }

  const url = resolveCashPayWindowUrl(payPayload, payType);
  if (!url) return false;
  const w = window.open(url, "_blank");
  return !!w;
}
